import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { class: "top-menu-vue element-to-hide" }
const _hoisted_3 = { style: {"height":"0.2em","margin":"0","background-color":"#eee"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.progressBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Menubar, { model: _ctx.menuItems }, null, 8, ["model"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.progressBar)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              style: {"height":"0.2em"}
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}